import styled from 'styled-components';
import { chartOrange, chartJaffaOrange, black } from 'styles/colors';
import {
	ApModal,
	ApButtonMain,
	ApButtonSecondary,
} from '@alixpartners/ui-components';

export const BottomSection = styled.div`
	display: flex;
	padding: 12px 0;
	align-items: center;
	justify-content: center;
	border-top: 3px solid ${chartOrange};
`;

export const PublishButton = styled(ApButtonMain)`
	margin-left: 40px;
	background: ${chartOrange} !important;

	&:hover {
		background: ${chartJaffaOrange} !important;
	}
`;

export const Text = styled.div`
	color: ${black};
	font-size: 13px;
	font-weight: 500;
	letter-spacing: 0.3px;
	line-height: 19px;
`;

export const StyledModal = styled(ApModal)`
	.ap-modal-content {
		max-width: 480px;
	}

	.ap-modal-header {
		border-bottom: none;
		padding: 27px 32px 8px 32px;
	}

	.ap-modal-footer {
		padding: 13px 32px 12px 32px;
	}

	.ap-modal-body {
		padding: 16px 32px 40px 32px;
	}
`;

export const ModalBody = styled.div`
	color: ${black};
	font-size: 16px;
	letter-spacing: 0.3px;
	line-height: 24px;

	p + p {
		margin-top: 10px;
	}
`;

export const StyledButtonSecondary = styled(ApButtonSecondary)`
	margin-right: 32px;
`;

export const ModalHeader = styled.div`
	color: ${black};
	font-size: 23px;
	font-weight: 500;
	letter-spacing: 0.3px;
	line-height: 31px;
`;
